import { createContext } from 'react'
import { OrderFrom } from './orderSourceValues'

export interface OrderSource {
    orderFrom: OrderFrom | null
    orderEntryPoint: string | null
}

export interface OrderSourceContextType {
    orderSource: OrderSource
    setOrderSource: (orderFrom: OrderSource['orderFrom'], orderEntryPoint: OrderSource['orderEntryPoint']) => void
    clearOrderSource: () => void
}

export const OrderSourceContext = createContext<OrderSourceContextType | undefined>(undefined)
